<script>
import configuration from '@/config'

export default {
  name: 'sidebar-footer',
  data () {
    return {
      config: {},
      logoInterno: null
    }
  },
  props: {
    logo: {
      type: Object,
      required: false,
      default: null
    }
  },
  async created () {
    this.config = configuration
    if (this.logo && this.logo.id) this.logoInterno = this.config.api.base + '/arquivo/' + this.logo.id + '/public'
  }
}
</script>
<template>
  <span :class="[logoInterno && logoInterno.id ? 'sidebar-nav-footer-logo' : 'sidebar-nav-footer']" :style="{background: `url(${logoInterno}) center bottom no-repeat`, backgroundSize: 'contain'}">
  </span>
</template>



// WEBPACK FOOTER //
// footer.vue?ef669d04